import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { classNames } from "../../common/css";

export const Success = (props) => {
  const { title, children, className, actions } = props;

  return (
    <div
      className={classNames(
        "rounded-lg border border-green-200 dark:border-green-500/30 bg-green-50 dark:bg-green-500/10 p-4 shadow-sm",
        className
      )}
    >
      <div className="flex flex-col items-start text-left">
        <div className="shrink-0 mb-3">
          <CheckCircleIcon
            className="h-8 w-8 text-green-500 dark:text-green-400 mx-auto"
            aria-hidden="true"
          />
        </div>
        <div className="w-full">
          {title && (
            <h3 className="text-lg font-semibold text-green-800 dark:text-green-300 mb-2">
              {title}
            </h3>
          )}
          {children && (
            <div className="text-sm text-green-700 dark:text-green-400 leading-relaxed text-left">
              {children}
            </div>
          )}
          {actions && <div className="mt-3 flex justify-center space-x-3">{actions}</div>}
        </div>
      </div>
    </div>
  );
};
